<!--机构管理-->
<template>
  <a-card>
    <div class="search" @keyup.enter="getPageList(1)">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="机构名称">
          <a-input :maxLength="30" allowClear v-model="searchForm.name" placeholder="请输入机构名称" />
        </a-form-model-item>
        <a-form-model-item label="机构地址">
          <a-cascader v-model="searchForm.address" :options="addressOptions" :load-data="addressLoadData" @change="addressChange" placeholder="请选择机构地址" change-on-select allowClear />
        </a-form-model-item>
        <a-form-model-item label="机构类型">
          <!-- <a-cascader v-model="searchForm.orgType" :options="orgTypeoptions" placeholder="请选择机构类型" /> -->
          <a-select class="serach-item" allowClear v-model="searchForm.orgType" placeholder="请选择机构类型">
            <a-select-option value="0">官方自营</a-select-option>
            <a-select-option value="1">学校</a-select-option>
            <a-select-option value="2">机构</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务类型">
          <a-select class="serach-item" allowClear v-model="searchForm.businessType" placeholder="请选择业务类型">
            <a-select-option :value="0">B端业务</a-select-option>
            <a-select-option :value="1">C端业务</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="上级机构">
          <SelectTree style="width: 180px" class="serach-item" v-model="searchForm.superiorId" :data="treeData" />
        </a-form-model-item>
        <a-form-model-item label="负责人" class="courseAbilityList">
          <a-select style="min-width: 180px" show-search :filter-option="filterOption" allowClear v-model="searchForm.adminIds" mode="multiple" placeholder="请选择负责人">
            <a-select-option :value="item.adminId + ''" v-for="item in adminList" :key="item.id">
              {{ item.adminName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select class="serach-item" allowClear v-model="searchForm.enabled" placeholder="请选择状态">
            <a-select-option :value="'true'">启用</a-select-option>
            <a-select-option :value="'false'">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询</a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`projectImpl.Organization.Add`">
          <a-button @click="addProjectClick" icon="plus" type="primary">添加机构</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`projectImpl.Organization.Merge`">
          <a-button @click="mergeOrg" type="primary">合并机构</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`projectImpl.Organization.adminStatistic`">
          <a-button @click="$router.push('/projectImpl/pMechanism/adminStatistic')" type="primary">管理机构数据统计</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto">
      <a-table
        :rowKey="(record) => JSON.stringify(record)"
        :row-selection="rowSelection"
        style="min-width: 800px"
        :columns="columns"
        :pagination="tablePagination"
        :loading="tableLoading"
        :dataSource="dataSource"
      >
        <div slot="dataKey" slot-scope="text, record" class="org-tag">
          <div class="tag-box">
            <a-tag v-if="record.property == 0" color="pink"> 管</a-tag>
            <a-tag v-if="record.informal" color="#13c2c2" style="margin-top: 2px"> 测</a-tag>
          </div>
        </div>
        <span slot="name" slot-scope="text, record">
          {{ text }}
        </span>
        <span slot="address" slot-scope="text">
          {{ text.province + text.city + text.district }}
        </span>
        <span slot="orgType" slot-scope="text, record">
          <span v-if="record.orgType == 0">官方自营</span>
          <span v-if="record.orgType == 1">学校</span>
          <span v-if="record.orgType == 2">机构</span>
          <span v-if="record.orgType == 3">第三方平台</span>
          <!-- <span v-if="record.orgType == 4">企业</span>
                    <span v-if="record.orgType == 5">单位</span> -->
          <span v-if="record.orgType == 6">脑智家游</span>
          <span v-if="record.businessType == 1">-C端业务</span>
          <span v-else>-B端业务</span>
        </span>
        <span slot="officer" :title="record.officers.join('、')" slot-scope="text, record">
          <span v-for="(item, index) in record.officers" style="margin: 0 5px" :key="index">{{ item }}</span>
        </span>
        <span v-auth="`projectImpl.Organization.Enabled`" slot="enabled" slot-scope="text">
          <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" :disabled="!text.canOperate" un-checked-children="禁用" />
        </span>
        <span slot="uneffectiveDate" slot-scope="text, record">
          <span>{{ record.uneffectiveDate.split(' ')[0] }}</span>
        </span>
        <div slot="status" slot-scope="text">
          <span v-if="text.status == 1">
            <span class="_green"></span>
            生效中
          </span>
          <span v-if="text.status == 2">
            <span class="_red"></span>
            已过期
          </span>
        </div>
        <div slot="action" class="action" :disabled="!text.canOperate" slot-scope="text">
          <a v-permission="`projectImpl.Organization.Detail`" @click="toDetails(text)"> 机构详情 </a>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-permission="`projectImpl.Organization.Edit`" @click="editProject(text)">
                  <a-icon type="edit" />
                  编辑
                </a>
              </a-menu-item>
              <a-menu-item>
                <a style="color: #f00" @click="deleteOrg(text.id)">
                  <a-icon type="delete" />
                  删除
                </a>
              </a-menu-item>
              <a-menu-item>
                <a @click="toLogin(text)">直接登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
    </div>

    <!--添加机构-->
    <a-modal
      :centered="true"
      v-model="addProject.visible"
      :title="addProject.title"
      width="100%"
      wrapClassName="create-report"
      @ok="addProjectOk"
      @cancel="addProjectCancel"
      :closable="false"
      :confirm-loading="addProject.confirmLoading"
    >
      <a-spin tip="Loading..." :spinning="addProject.confirmLoading" class="modal-body">
        <div class="steps">
          <a-steps :current="currentSteps" labelPlacement="vertical">
            <a-step title="基础信息"></a-step>
            <a-step title="开通智慧云服务" />
          </a-steps>
        </div>
        <keep-alive>
          <OrganizationForm v-if="currentSteps == 0" :title="addProject.title" :orgId="addProject.id" :key="addProject.key" ref="organizationForm" />
          <Step2 v-if="currentSteps == 1" />
        </keep-alive>
      </a-spin>
      <template slot="footer">
        <div class="modal-footer">
          <a-button :disabled="addProject.confirmLoading" @click="addProjectCancel">取消</a-button>
          <a-button :disabled="addProject.confirmLoading" type="primary" @click="nextStep">
            {{ currentSteps == 1 ? '上一步' : '下一步' }}
          </a-button>
          <a-button :loading="addProject.confirmLoading" v-if="currentSteps == 1" type="primary">完成</a-button>
        </div>
      </template>
    </a-modal>

    <!-- 合并机构 -->
    <a-modal width="60%" title="合并机构" :visible="merge.visible" @cancel="closeMerge" @ok="submitMerge" okText="提交合并" :confirm-loading="merge.confirmLoading">
      <p style="font-weight: bold; font-size: 16px; margin: 30px 0">
        选择合并主体<span style="font-weight: normal; color: #bbb; font-size: 14px; margin-left: 5px">合并后信息以主体为准，包括机构基本信息</span>
      </p>
      <a-table
        :columns="mergeColumns"
        row-key="id"
        :row-selection="mergeRowKeys"
        :pagination="merge.tableRelevant.tablePagination"
        :loading="merge.tableRelevant.tableLoading"
        :locale="merge.tableRelevant.locale"
        :data-source="merge.tableRelevant.tableDataSource"
      >
        <span slot="address" slot-scope="text">
          {{ text.province + text.city + text.district }}
        </span>
        <span slot="orgType" slot-scope="text, record">
          <span v-if="record.orgType == 0">平台</span>
          <span v-if="record.orgType == 1">学校</span>
          <span v-if="record.orgType == 2">机构</span>
          <span v-if="record.orgType == 3">第三方平台</span>
          <!-- <span v-if="record.orgType == 4">企业</span>
                    <span v-if="record.orgType == 5">单位</span> -->
          <span v-if="record.orgType == 6">脑智家游</span>
          <!-- <span v-if="record.orgType == 7">直销机构</span> -->
        </span>
        <span slot="officer" :title="record.officers.join('、')" slot-scope="text, record">
          <span v-for="item in record.officers" :key="item" style="margin: 0 5px">{{ item }}</span>
        </span>
        <span slot="enabled" slot-scope="text, record">
          {{ text.enabled ? '启用' : '禁用' }}
        </span>
        <span slot="uneffectiveDate" slot-scope="text, record">
          <span>{{ record.uneffectiveDate.split(' ')[0] }}</span>
        </span>
        <div slot="status" slot-scope="text">
          <span v-if="text.status == 1">
            <span class="_green"></span>
            生效中
          </span>
          <span v-if="text.status == 2">
            <span class="_red"></span>
            已过期
          </span>
        </div>
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import StandardTable from '@/components/table/StandardTable'
import { CheckPhone, tableRelevant } from '@/pages/projectImpl/js/utils'
import OrganizationForm from '@/pages/projectImpl/orgManage/components/OrganizationForm.vue'
import Step2 from '@/pages/projectImpl/orgManage/components/orgStep2.vue'
import SelectTree from '@/components/SelectTree'

const columns = [
  {
    title: '',
    key: '89',
    dataIndex: 'dataKey',
    scopedSlots: { customRender: 'dataKey' },
    width: '60px',
  },
  {
    title: '机构名称',
    key: '1',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '地址',
    key: '4',
    scopedSlots: { customRender: 'address' },
    align: 'center',
  },
  {
    title: '机构类型',
    key: '8',
    scopedSlots: { customRender: 'orgType' },
    align: 'center',
  },
  {
    title: '上级机构',
    key: '9',
    dataIndex: 'superiorName',
    align: 'center',
  },
  {
    title: '负责人',
    key: '2',
    scopedSlots: { customRender: 'officer' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '状态',
    key: '5',
    scopedSlots: { customRender: 'enabled' },
    align: 'center',
  },
  {
    title: '操作',
    key: '3',
    scopedSlots: { customRender: 'action' },
    align: 'center',
    width: 150,
  },
]
const mergeColumns = [
  {
    title: '机构名称',
    key: '1',
    dataIndex: 'name',
    align: 'center',
  },
  {
    title: '地址',
    key: '4',
    scopedSlots: { customRender: 'address' },
    align: 'center',
  },
  {
    title: '机构类型',
    key: '8',
    scopedSlots: { customRender: 'orgType' },
    align: 'center',
  },
  {
    title: '上级机构',
    key: '9',
    dataIndex: 'superiorName',
    align: 'center',
  },
  {
    title: '负责人',
    key: '2',
    scopedSlots: { customRender: 'officer' },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '状态',
    key: '5',
    scopedSlots: { customRender: 'enabled' },
    align: 'center',
  },
]

const orgTypeoptions = [
  {
    label: '官方自营',
    value: 0,
  },
  {
    label: '学校',
    value: 1,
  },
  {
    label: '机构',
    value: 2,
  },
]
export default {
  name: 'QueryList',
  components: { StandardTable, OrganizationForm, Step2, SelectTree },
  data() {
    return {
      orgTypeoptions: Object.freeze(orgTypeoptions),
      currentSteps: 0,
      //搜索
      searchForm: {
        name: this.$route.query.name,
        orgType: [],
        provinceId: undefined,
        cityId: undefined,
        districtId: undefined,
        address: undefined,
        enabled: this.$route.query.enabled,
        status: this.$route.query.status,
        superiorId: Number(this.$route.query.superiorId) || undefined,
        adminIds: this.$route.query.adminIds,
      },
      //地址
      addressOptions: [],
      //表格分页
      tablePagination: tableRelevant.call(this).tablePagination,
      //表格加载菊花
      tableLoading: false,
      columns: columns,
      dataSource: [],
      selectedRows: [],
      treeData: [],
      //新增机构
      addProject: {
        title: '新增机构',
        visible: false,
        confirmLoading: false,
        key: Date.now(),
        id: undefined,
      },
      adminList: [], //机构负责人

      selectedRowKeys: [],
      mergeColumns,
      merge: {
        visible: false,
        confirmLoading: false,
        tableRelevant: tableRelevant.call(this),
        rowKeys: [],
      },
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
        getCheckboxProps: (record) => ({
          props: {
            // 管理机构/无权限时禁用
            disabled: record.superiorOrganization || !record.canOperate,
          },
        }),
      }
    },
    mergeRowKeys() {
      return {
        type: 'radio',
        selectedRowKeys: this.merge.rowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.merge.rowKeys = selectedRowKeys
          console.log(this.merge.rowKeys)
        },
      }
    },
  },
  mounted() {
    this.getPageList()
    this.getAddressList()
    this.getAdminList()
    this.getTreeData(5)
  },
  methods: {
    async nextStep() {
      if (this.currentSteps == 0) {
        await this.addProjectOk()
        this.currentSteps = 1
      } else {
        this.currentSteps = 0
      }
      console.log(this.currentSteps)
    },
    closeMerge() {
      this.merge.visible = false
      this.selectedRowKeys = []
      this.merge.rowKeys = []
      this.merge.tableRelevant.tableDataSource = []
    },
    mergeOrg() {
      this.$message.destroy()
      if (this.selectedRowKeys.length < 2) {
        this.$message.warning('请至少选择2个机构')
        return
      }
      console.log(this.selectedRowKeys)
      this.selectedRowKeys.forEach((v) => {
        console.log(JSON.parse(v))
        this.merge.tableRelevant.tableDataSource.push(JSON.parse(v))
      })
      this.merge.tableRelevant.tableDataSource.forEach((v) => {
        v.times = new Date(v.createTime).getTime()
      })
      this.merge.tableRelevant.tableDataSource.sort(function (a, b) {
        return a.times - b.times
      })
      this.merge.rowKeys.push(this.merge.tableRelevant.tableDataSource[0].id)
      this.merge.visible = true
    },
    submitMerge() {
      this.$message.destroy()
      if (!this.merge.rowKeys.length) {
        this.$message.warning('请选择合并主体')
        return
      }
      let formData = new FormData()
      this.merge.tableRelevant.tableDataSource.forEach((v) => {
        if (v.id != this.merge.rowKeys[0]) {
          formData.append('originalOrganizationIds', v.id)
        }
      })
      formData.append('targetOrganizationId', this.merge.rowKeys[0])
      this.merge.confirmLoading = true
      this.$http.Mechanism.mergeOrganization(formData).then((res) => {
        this.merge.confirmLoading = false
        const { message } = res
        this.$message.success(message)
        this.closeMerge()
        this.getPageList(1)
      })
    },

    deleteOrg(id) {
      this.$confirm({
        title: `确认删除该机构？`,
        content: '机构删除后所有相关数据都将删除且不可恢复，请谨慎操作',
        centered: true,
        onOk: () => {
          let formData = new FormData()
          formData.append('id', id)
          this.$message.destroy()
          this.$http.Mechanism.deleteOrg(formData).then((res) => {
            const { message } = res
            this.$message.success(message)
            this.getPageList(1)
          })
        },
      })
    },
    //获取所有负责人
    getAdminList() {
      this.$http.Mechanism.GetOrganizationAdmin().then((res) => {
        const { data } = res
        this.adminList = data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    //获取上级机构
    getTreeData(type, organizationId) {
      let params = {
        type: type,
      }
      if (type == 2) {
        params.organizationId = organizationId
      }
      this.$http.Mechanism.getSuperiorTree(params).then((res) => {
        const { data } = res
        this.treeData = data
      })
    },
    //重置
    searchReset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = undefined
      }
      this.getPageList(1)
    },
    //新增机构
    addProjectOk() {
      return new Promise((resolve, reject) => {
        this.$refs.organizationForm.validate((valid) => {
          if (valid) {
            const Ajax = this.addProject.title === '编辑机构' ? this.$http.Mechanism.mechanismOrganizationUpdate : this.$http.Mechanism.mechanismOrganizationAdd
            this.addProject.confirmLoading = true
            Ajax(this.$refs.organizationForm.form)
              .then((res) => {
                this.addProject.confirmLoading = false
                const { data } = res
                // InterfaceHttp 已经显示了成功消息
                // this.addProject.visible = false
                // this.addProjectCancel()
                // this.getPageList(1)
                resolve(data)
              })
              .catch((e) => {
                this.addProject.confirmLoading = false
                // 网络错误等异常，InterfaceHttp 可能已经显示了错误消息
                reject()
              })
          } else {
            reject()
            return false
          }
        })
      })
    },
    addProjectClick() {
      return this.$router.push({ path: '/projectImpl/pMechanism/updateMechanism' })
      this.addProject.title = '新增机构'
      this.addProject.id = undefined
      this.addProject.key = Date.now()
      this.addProject.visible = true
    },
    //新增机构弹出层关闭
    addProjectCancel() {
      if (this.currentSteps == 1) {
        return this.$confirm({
          title: `确认放弃该步骤填写？`,
          content: '',
          centered: true,
          onOk: () => {
            this.addProject.title = '新增机构'
            this.$refs.organizationForm && this.$refs.organizationForm.resetForm()
            this.addProject.visible = false
            this.currentSteps == 0
          },
        })
      }
      this.addProject.title = '新增机构'
      this.$refs.organizationForm && this.$refs.organizationForm.resetForm()
      this.addProject.visible = false
      this.currentSteps == 0
    },
    //编辑机构
    editProject(val) {
      return this.$router.push({ path: '/projectImpl/pMechanism/updateMechanism', query: { id: val.id } })
      let params = {
        organizationId: val.id,
      }
      this.addProject.id = val.id
      this.addProject.title = '编辑机构'
      this.addProject.key = Date.now()
      this.addProject.visible = true
      this.$http.UserManage.getOrganizationInfo(params).then((res) => {
        const { data } = res
        this.$nextTick(() => {
          for (const formKey in this.$refs.organizationForm.form) {
            this.$refs.organizationForm.form[formKey] = data[formKey]
          }
          this.$refs.organizationForm.id = params.organizationId || undefined
          this.$refs.organizationForm.form.superiorId = data.superiorId || undefined
          this.$refs.organizationForm.form.adminIds = data.admins.map((m) => m.adminId)
          this.$refs.organizationForm.form.roleIds = data.roles.map((m) => m.roleId)
          this.$refs.organizationForm.setting()
        })
      })
    },
    //机构详情
    toDetails(val) {
      console.log(this.$route.fullPath)
      sessionStorage.setItem('ORGANIZATION_ID', val.id)
      sessionStorage.setItem('ORGANIZATION_TYPE', val.orgType)
      sessionStorage.setItem('ORGANIZATION_NAME', val.name)
      sessionStorage.setItem('ORGANIZATION_SUPERIORID', val.superiorId)
      this.$store.commit('organization/setActiveKey', 0)
      this.$store.commit('organization/setOrganizationFullPath', this.$route.fullPath)
      // this.$router.push("/projectImpl/organizationDetails");
      this.$router.push({
        path: '/projectImpl/pMechanism/orgDetails',
        query: {
          id: val.id,
          uneffectiveDate: val.uneffectiveDate,
        },
      })
    },
    //表格启用禁用
    tableStatusChange(val) {
      const formData = new FormData()
      formData.append('organizationId', val.id)
      formData.append('enabled', val.enabled)
      this.$http.Mechanism.mechanismTableStatus(formData)
        .then((res) => {
          this.$message.destroy()
          this.$message.success(res.message)
        })
        .catch((e) => {
          val.enabled = !val.enabled
        })
    },
    //获取机构列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tablePagination.current = pageIndex
      }

      let params = {
        pageIndex: pageIndex || this.tablePagination.current,
        pageSize: this.tablePagination.pageSize,
        ...this.searchForm,
      }
      if (Array.isArray(params.orgType)) {
        const orgType = params.orgType
        params.orgType = orgType[0]
      }
      this.$router.push({
        query: params,
      })
      this.tableLoading = true
      this.$http.Mechanism.mechanismPageList(params).then((res) => {
        const { data } = res
        this.tableLoading = false
        data.items.forEach((v) => {
          let old = new Date(v.uneffectiveDate).getTime() + 24 * 60 * 60 * 1000
          if (Date.now() > old) {
            v.status = 2
          } else {
            v.status = 1
          }
        })
        this.dataSource = data.items
        this.tablePagination.total = data.totalCount
        this.tablePagination.current = data.pageIndex
      })
    },

    /**
     * 获取地址
     * @param id 查询的省市区
     */
    getAddressList(id) {
      return new Promise((resolve, reject) => {
        this.$http.Mechanism.address({ parentId: id || 0 }).then((res) => {
          const { data } = res
          if (id) {
            resolve(
              data.map((v) => {
                return {
                  id: v.id,
                  value: v.id + ',' + v.name,
                  label: v.name,
                  isLeaf: v.level === 4,
                  loading: false,
                }
              })
            )
          } else {
            this.addressOptions = data.map((v) => {
              return {
                id: v.id,
                value: v.id + ',' + v.name,
                label: v.name,
                isLeaf: false,
                loading: false,
              }
            })
          }
          return
        }, reject)
      })
    },
    addressLoadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      return this.getAddressList(targetOption.value.split(',')[0]).then((data) => {
        targetOption.loading = false
        targetOption.children = data
        this.addressOptions = [...this.addressOptions]
        return data
      })
    },
    addressChange(value) {
      this.searchForm.provinceId = value[0] && value[0].split(',')[0]
      this.searchForm.cityId = value[1] && value[1].split(',')[0]
      this.searchForm.districtId = value[2] && value[2].split(',')[0]
    },

    // 免密登录
    toLogin(record) {
      let baseUrl = ''
      if (process.env.VUE_APP_ENVIRONMENT === 'preview') {
        // 正式
        baseUrl = 'https://cloud.iquizoo.com/'
      } else if (process.env.VUE_APP_ENVIRONMENT === 'uat') {
        // 预发布
        baseUrl = 'http://cloud.uat.iquizoo.com/'
      } else {
        // 测试
        baseUrl = 'http://cloud.alpha.iquizoo.com/'
      }
      const Url = baseUrl + 'jump?adminId=' + this.$store.getters['account/user'].id + '&orgId=' + record.id + '&orgType=' + record.orgType + '&orgName=' + record.name
      console.log(Url)
      window.open(Url)
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  .ant-form-item {
    margin-bottom: 15px;
  }

  .serach-item {
    width: 180px;
  }
}

.getCode {
  position: absolute;
  bottom: -7px;
  margin-left: 15px;
}

._green {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background: green;
}

._red {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background: red;
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}

// /deep/ .ant-select-tree-switcher-noop{
//     display:none;
// }
.courseAbilityList /deep/ li.ant-select-dropdown-menu-item {
  margin: 8px 0;
}

.courseAbilityList /deep/ .ant-select-dropdown-menu-item-selected {
  background-color: #b5f5ec;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: normal;
}

/deep/ .create-report .ant-modal {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 0;
}

/deep/ .create-report .ant-modal-content {
  min-height: 100vh;
  padding-bottom: 0;
}

.org-tag {
  position: relative;

  .tag-box {
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ::v-deep .ant-tag {
    padding: 0 4px;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    vertical-align: middle;
  }
}
</style>
